import { useContext } from 'react';
import { UIThemeContext } from 'Jsx/Shared/LayoutV2/UITheme';

function useUITheme() {
  const context = useContext(UIThemeContext);

  if (context === undefined) {
    throw new Error(
      'useUITheme must be used within a UITheme provider. To include it with LayoutV2, the prop withUITheme must be true.',
    );
  }

  return context;
}

export default useUITheme;
